'use strict'

/**
 * Vue Club
 */

import master from 'Modules/master'
import rollingTexts from 'Modules/rollingTexts'
import ajaxLoader from 'Modules/ajaxLoader'
import validateIban from 'Modules/ibanValidator'
import modal from 'Modules/modal'

const descRetourMap = {
    3: $t('DESC_RETOUR_3'),
    9: $t('DESC_RETOUR_9'),
    19: $t('DESC_RETOUR_19'),
    21: $t('DESC_RETOUR_21')
}

master.process()
rollingTexts.init()

/**
 * RETOUR / REMBOURSEMENT
 */

$('.SelectMotif').change(function () {
    const refProduit = $(this).data('refproduit')
    const motifsRetours = JSON.parse(document.getElementById('dataMotifs').dataset.motifs)
    const motif = motifsRetours.find((m) => m.Value === $(this).val())

    $('#descDiv' + refProduit).hide()
    $('#labeldesc' + refProduit).hide()

    var idProduit = $(this).attr('data-refproduit')
    if (motif.Value != '18') {
        if (!$('#styled-checkbox-' + idProduit).is(':checked')) {
            $('#styled-checkbox-' + idProduit).trigger('click')
            $('#styled-checkbox-' + idProduit)
                .parents('.ligneProdRet')
                .addClass('before-bg--transparent-pink')
            $('.club-mesretours .validRet').prop('disabled', false)
            $('.contentBtnMC__mention-retractation').show()
        }
    } else {
        if ($('#styled-checkbox-' + idProduit).is(':checked')) {
            $('#styled-checkbox-' + idProduit)
                .parents('.ligneProdRet')
                .removeClass('before-bg--transparent-pink')
            $('#styled-checkbox-' + idProduit).trigger('click')

            if ($('.chkArticleEligible.styled-checkbox:checked').length == 0) {
                $('.club-mesretours .validRet').prop('disabled', true)
                $('.contentBtnMC__mention-retractation').hide()
            }
        }
    }

    if (motif.ModeAffichageDescription == 'masque') {
        return
    }

    $('#labeldesc' + refProduit)
        .html(descRetourMap[motif.Value])
        .show()

    if (motif.ModeAffichageDescription == 'label_seul') {
        $('#labeldesc' + refProduit).addClass('red')
        return
    }

    $('#labeldesc' + refProduit).removeClass('red')
    $('#descDiv' + refProduit).show()
})

$('#bValiderRetour').click(function () {
    const Refproduits = []
    let valide = true
    const motifsRetours = JSON.parse(document.getElementById('dataMotifs').dataset.motifs)

    $('.chkArticleEligible:checked').each(function (index) {
        const refProduit = $(this).data('refproduit')
        const refMotifRetour = $('#motif' + refProduit).val()
        const article = {
            refproduit: refProduit,
            refMotifRetour: refMotifRetour,
            description: $('#desc' + refProduit).val()
        }

        const motif = motifsRetours.find((m) => m.Value === refMotifRetour)
        if (motif.ModeAffichageDescription === 'input_obligatoire' && article.description == '') {
            $('#descDiv' + article.refproduit)
                .addClass('has-error')
                .removeClass('has-success')
            $('html,body').animate(
                {
                    scrollTop: 0
                },
                700
            )
            $('.retourref' + article.refproduit + ' label').addClass('red')
            valide = false
        } else if (motif.ModeAffichageDescription === 'input_obligatoire') {
            $('#descDiv' + article.refproduit)
                .addClass('has-success')
                .removeClass('has-error')
            $('.retourref' + article.refproduit + ' label').addClass('red')
            $('.retourref' + article.refproduit + ' label').addClass('black')
        }

        Refproduits.push(article)
    })

    if (Refproduits.length == 0) {
        return
    }
    if (valide == false) {
        return
    }

    modal.creer(
        'modal-retour',
        'modal-retour-article',
        window.location.origin + '/club/ChoixModeRetour',
        function () {
            import('Modules/choixModeRetour').then((obj) => obj.default.init())
        },
        'POST',
        JSON.stringify({ Refproduits: Refproduits }),
        'application/json; charset=utf-8',
        true
    )
})

$('.btnRembourser').on('click', submitRemboursement)

function submitRemboursement() {
    // Iban déjà enregistré
    if ($('.j_txtIban').length === 0) {
        $(this).parents('form').submit()
        return
    }

    // IBAN vide
    if ($('.j_txtIban').val() === '' || $('.j_txtIban').val() === undefined) {
        $('.j_ibanError').empty().append($t('DEVEZ_SAISIR_IBAN'))
        return
    }

    // IBAN invalide
    if (!validateIban($('.j_txtIban').val())) {
        $('.j_ibanError').empty().append($t('FORMAT_IBAN_INVALIDE'))
        return
    }

    // Ajoute la valeur de l'IBAN dans le champ du formulaire
    $('#ibanField').val($('.j_txtIban').val())

    // Submit le formulaire
    $(this).parents('form').submit()
}

/**
 * PARRAINAGE
 */

$('.j_btn_more_parrainage').on('click', function () {
    $(location).attr('href', document.location.href + '#parrainage')
})

if ($('#parrainvalid').val() == 1) {
    $('#modal_parrainage').modal('show')
    $('input[type=text]').val('')
}

if (document.getElementsByClassName('monParrainage__form').length > 0) {
    document
        .getElementsByClassName('monParrainage__form')[0]
        .addEventListener('submit', function (event) {
            var ok = false
            var listeElementEmail = document.getElementsByClassName('EmailParrainages')
            var nbElement = listeElementEmail.length

            for (var i = 0; i < nbElement; i++) {
                var elementEmail = listeElementEmail.item(i)
                if (elementEmail.value != '') {
                    ok = true
                }
            }

            if (!ok) {
                event.preventDefault()
                //ici ajouter le traitement si erreur
                document.querySelector('.error-parrainage').classList.add('AnimEror')
            }
        })
}

/**
 * CARTE CADEAU
 */

$('#tbCarteCadeau').keydown(function () {
    $('.btn-cadd-carte-cadeau').prop('disabled', false)
})

/**
 * MES ABONNEMENTS
 */

$('.club-gestionabonnement input[type="checkbox"]').click(function () {
    let isAbonnement = false

    if ($(this).prop('checked')) {
        isAbonnement = true
    }

    const params = { codFamille: $(this).val(), isAbonnement: isAbonnement }

    ajaxLoader.loadAndExecuteCallBack(
        'POST',
        params,
        function (content) {},
        function (content) {},
        ''
    )
})
